module.exports = __webpack_public_path__ + "img/hk.3d31271e.png";